"use client"

import * as React from "react"

import type { HomeD4Data } from "@/features/dashboard/home-d4/hooks/use-home-d4-data"

const HomeD4Context = React.createContext<HomeD4Data | null>(null)

/** Shares one fetch of the D4 data with every D4 widget the engine renders. */
export function HomeD4Provider({ value, children }: { value: HomeD4Data; children: React.ReactNode }) {
  return <HomeD4Context.Provider value={value}>{children}</HomeD4Context.Provider>
}

export function useHomeD4Context(): HomeD4Data | null {
  return React.useContext(HomeD4Context)
}
